<p-dialog [(visible)]="showAlert" [resizable]="false" [draggable]="false" [closable]="false"
    [style]="{width: '40%'}" [header]="title" [modal]="true" styleClass="p-fluid">

    <ng-template pTemplate="content">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-8" style="padding-top:2%">
                        <label for="label" class="form-label mb-1">{{message}}</label>
                    </div>
                    <div class="col-sm-3 button-items " style="padding:10px;">
                        <button type="button" class="btn btn-danger" style="float: right;"
                            (click)="reject()">No</button>
                        <button type="submit" class="btn btn-success" style="float: right;"
                            (click)="accept()">Yes</button>      
                    </div>
                </div>
                
            </div>
        </div>
    </ng-template>
</p-dialog>